module.exports = __webpack_public_path__ + "img/close.0da8cf26.svg";